import { FormattedMessage } from "react-intl"
import classNames from "classnames"

// Components
import {
  CustomButton,
  Modal,
  Spinner
} from "../../../common"

// Constants
import { GA_EVENTS } from "../../../../constants/analytics"

const DeleteConfirmModal = ({
  cvsLength = 0,
  open = false,
  setOpen = () => {},
  onConfirm = () => {},
  onCancel = () => {},
  loading = true,
}) => (
  <Modal open={open} setOpen={setOpen} className={"delete-dialog"}>
    <div className="delete-dialog__container">
      <h2 className="text-2xl font-bold">
        <FormattedMessage id="common.confirmDelete" />
      </h2>
      <p>
        <FormattedMessage
          id="message.areYouSureDeleteCVs"
          values={{ cvsLength }}
        />
      </p>
      {loading && <Spinner />}
      <div className="flex gap-2 delete-dialog__buttons">
        <CustomButton
          className={classNames("btn btn--small primary mr-2", {
            disabled: loading,
          })}
          onClick={onConfirm}
          disabled={loading}
          trackingEvent={GA_EVENTS.SELECT_CV.MODAL_DELETE}
        >
          <FormattedMessage id="common.delete" /> {cvsLength} CV
          {cvsLength > 1 ? "s" : ""}
        </CustomButton>
        <CustomButton
          className="btn btn--small"
          onClick={onCancel}
          trackingEvent={GA_EVENTS.SELECT_CV.MODAL_CANCEL}
        >
          <FormattedMessage id="common.cancel" />
        </CustomButton>
      </div>
    </div>
  </Modal>
);

export default DeleteConfirmModal;
